import yn from "yn";

// Whether the Add Table picker surfaces read-accessible tables (read-only
// references) instead of only write-accessible ones. Gated per deployment via
// VITE_READ_ONLY_TABLE_REFERENCES_ENABLED so it can be rolled out per customer
// environment.
export const useReadOnlyTableReferencesEnabled = (): boolean =>
  yn(import.meta.env.VITE_READ_ONLY_TABLE_REFERENCES_ENABLED, { default: false });
